/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconCheckAlt is deprecated and will be archived soon. Use IconCheckAlt instead.
 */

export function Experimental__IconCheckAlt(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path d='M6.247 10.08L3.938 7.377l-.658.769 2.966 3.473 5.558-6.508-.76-.649-4.797 5.618zM7.5 0a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 14C3.916 14 1 11.084 1 7.5S3.916 1 7.5 1 14 3.916 14 7.5 11.084 14 7.5 14z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M8.903 16.638l-3.716-4.35-.657.77 4.373 5.12 9.563-11.197-.76-.649-8.803 10.306zM11.5 0C5.149 0 0 5.149 0 11.5S5.149 23 11.5 23 23 17.851 23 11.5 17.851 0 11.5 0zm0 22C5.71 22 1 17.29 1 11.5S5.71 1 11.5 1 22 5.71 22 11.5 17.29 22 11.5 22z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M11.999 22.693l-5.122-5.997-.658.77 5.78 6.767L24.756 9.296l-.76-.649-11.997 14.046zM15.5 0C6.94 0 0 6.939 0 15.5 0 24.06 6.94 31 15.5 31S31 24.06 31 15.5C31 6.939 24.06 0 15.5 0zm0 30C7.505 30 1 23.495 1 15.5S7.505 1 15.5 1 30 7.505 30 15.5 23.495 30 15.5 30z'/>"
  }, {
    size: 48,
    svgContent: "<path d='M24 1C11.297 1 1 11.297 1 24s10.297 23 23 23 23-10.297 23-23S36.703 1 24 1zm0 44C12.42 45 3 35.579 3 24S12.42 3 24 3s21 9.421 21 21-9.42 21-21 21zm10.18-31.114L19.489 31.087l-6.148-7.198-1.315 1.54 7.463 8.738 16.212-18.982-1.521-1.299z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M25.311 42.872l-7.92-9.273-1.315 1.54 9.235 10.813 20.236-23.694-1.521-1.299-18.715 21.913zM32 4.001c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28c0-15.465-12.536-28-28-28zM32 58C17.663 58 6 46.337 6 32 6 17.664 17.663 6 32 6c14.336 0 26 11.663 26 26S46.336 58 32 58z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z'/><path d='M11.079 5.47a.75.75 0 010 1.06l-4.53 4.53-2.08-2.078a.75.75 0 111.061-1.06l1.02 1.016 3.47-3.47a.75.75 0 011.06 0z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z'/><path d='M17.398 8.207a1 1 0 010 1.414l-7.425 7.425-3.308-3.308a1 1 0 011.414-1.414l1.894 1.894 6.011-6.011a1 1 0 011.414 0z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconCheckAlt;